// import wx from 'weixin-js-sdk'
import request from '@/utils/request'
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;

// 获取微信token
export function getAccessToken (data) {
    return request({
        url: GateWay + '/wx/getAccessToken',
        method: 'post',
        data
    })
}
// 获取支付宝token
export function getZfbAccessToken (data) {
    return request({
        url: GateWay + '/aliapy/getUserIdByAuthCode',
        method: 'post',
        data
    })
}
// // 统一下单接口 新
// export function unifiedOrder (data) {
//     return request({
//         url:GateWay +  '/WXPay/pay',
//         method: 'post',
//         data
//     })
// }
// 统一下单接口 旧
export function unifiedOrder (data) {
    return request({
        url: GateWay + '/wx/unifiedOrder',
        method: 'post',
        data
    })
}
// 获取微信用户信息
export function getWxUserInfo (data) {
    return request({
        url: GateWay + '/wx/getWxUserInfo',
        method: 'post',
        data
    })
}
// 通过code码鉴权wx
export function getAccessByCode (AppId, local, which) {
    if (which == 'wx') {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${AppId}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=1001#wechat_redirect`
    } else if (which == 'zfb') {
        window.location.href = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${AppId}&scope=auth_user&redirect_uri=${encodeURIComponent(local)}`
    }
}

// 微信支付
// export function weixinPay(data, cb, errorCb) {
//   //获取后台传入的数据
//   let appId = data.appId
//   let timestamp = data.timeStamp
//   let nonceStr = data.nonceStr
//   let signature = data.signature
//   let packages = `prepay_id=${data.package}`
//   let paySign = data.paySign
//   let signType = data.signType
//   wx.config({
//     debug: process.env.NODE_ENV === 'development', // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//     appId: appId, // 必填，公众号的唯一标识
//     timestamp: timestamp, // 必填，生成签名的时间戳
//     nonceStr: nonceStr, // 必填，生成签名的随机串
//     signature: signature, // 必填，签名，见附录1
//     jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//   })

//   wx.ready(function() {
//     wx.chooseWXPay({
//       timestamp: timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
//       nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
//       package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
//       signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
//       paySign: paySign, // 支付签名
//       success: function(res) {
//         // 支付成功后的回调函数
//         cb(res)
//       },
//       fail: function(res) {
//         //失败回调函数
//         errorCb(res)
//       }
//     })
//   })
//   wx.error(function(res) {
//     errorCb(res)
//     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
//   })
// }
export function aliPay (data, callback) {
    let vm = this
    if (typeof AlipayJSBridge == 'undefined') {
        document.addEventListener('AlipayJSBridgeReady', vm.zfbonBridgeReady(data, callback), false)
    } else {
        zfbonBridgeReady(data, callback)
    }
}

export function weixinPay (data, callback) {
    var vm = this
    if (typeof WeixinJSBridge == 'undefined') {
        //微信浏览器内置对象。参考微信官方文档
        if (document.addEventListener) {
            document.addEventListener(
                'WeixinJSBridgeReady',
                vm.wxonBridgeReady(data, callback),
                false
            )
        } else if (document.attachEvent) {
            document.attachEvent(
                'WeixinJSBridgeReady',
                vm.wxonBridgeReady(data, callback)
            )
            document.attachEvent(
                'onWeixinJSBridgeReady',
                vm.wxonBridgeReady(data, callback)
            )
        }
    } else {
        wxonBridgeReady(data, callback)
    }
}

function wxonBridgeReady (params, callback) {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, callback)
}
function zfbonBridgeReady (params, callback) {
    window.AlipayJSBridge.call('tradePay', params, callback)
}